import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Pedido } from 'src/app/model/Pedido';
import { AuthComprasService } from 'src/app/service/auth-compras.service';
import { ConsultaService } from 'src/app/service/consulta.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Component({
  selector: 'app-minhas-compras',
  templateUrl: './minhas-compras.component.html',
  styleUrls: ['./minhas-compras.component.scss']
})
export class MinhasComprasComponent implements OnInit, OnDestroy {

  isLoading = signal<boolean>(true);
  pedidos = signal<Pedido[]>([]);
  error: string | null = null;
  panelOpenState = false;

  constructor(
    public authService: AuthComprasService, 
    private consultaService: ConsultaService,
    private dialog: MatDialog
  ) { } // O serviço se torna público

  ngOnInit(): void {
    this.listaPedidos();
  }

  ngOnDestroy(): void {
    // A chamada para limpar os dados permanece aqui
    this.authService.clearLoginData();
  }

  listaPedidos(): void {
    this.consultaService.consultaPedidoResponsavel({cpf: this.authService.cpf()!}, this.authService.token()!)
    .pipe(finalize(() => this.isLoading.set(false)))
    .subscribe({
      next: (response) => {
        if(response.status) {
          this.pedidos.set(response.pedidos);
        } else {
          this.dialog.open(DialogComponent, { data: response.mensagem });
          this.error = response.mensagem || 'Erro ao buscar pedidos.';
        }
      },
      error: (err: Error) => {
        this.dialog.open(DialogComponent, { data: err.message });
        console.error('Erro no componente ao buscar pedidos:', err);
      }
    });
  }

  public formatarData(input: string): string {
    //de: 2023-10-05 14:30:00
    //para: 05/10/2023 14:30
    const regex = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}:\d{2}).*$/;
    return input.replace(regex, "$3/$2/$1 $4");
  }

  public getStatusClass(status: string): string {
    const map: { [key: string]: string } = {
      'Aguardando Processamento': 'aguardando',
      'Pedido recebido e em processamento': 'processando',
      'Pedido rejeitado - Ligue para 0800990606': 'rejeitado',
      'Aguardando Pagamento': 'pagamento',
      'Pedido Cancelado': 'cancelado',
      'Pedido Enviado': 'enviado',
      'Separado para Postagem': 'separado',
      'Cartão Aprovado': 'cartao',
      'Pedidos Antigos!': 'antigo',
      'Entrega confirmada pelo Correios': 'correios',
      'Entrega confirmada pelo cliente': 'cliente',
      'Finalizado por tempo': 'tempo',
      'Pagamento Aprovado': 'aprovado',
      'Faturado': 'faturado',
    };

    return map[status] || 'default';
  }

}